// extracted by mini-css-extract-plugin
export default {"logoImage1":"welcome_logoImage1__xquIs","welcomePageDiv":"welcome_welcomePageDiv__RO+yA","welcomePage":"welcome_welcomePage__Qo5dT","mainWelcomeDiv":"welcome_mainWelcomeDiv__AiLPC"};